<template>
    <!--error section area start-->
    <div class="error_section">
        <div class="container">   
            <div class="row">
                <div class="col-12">
                    <div class="error_form">
                        <img src="/assets/img/checkmark.png" style="height: 64px; margin: 14px;">
                        <h2>Đơn hàng đã được đặt</h2>
                        <p>Đơn hàng của bạn đã được đặt. ID đơn hàng của bạn là <b>{{ currentId }}</b></p>
                        <a @click="gotoAccount" style="color: #fff">Xem chi tiết đơn hàng</a>
                    </div>
                </div>
            </div>
        </div>    
    </div>
    <!--error section area end--> 
</template>
<script>
export default {
    computed: {
        currentId() {
            return this.$route.params.Pid;
        }
    },
    methods: {
        gotoAccount() {
            window.getApp.$router.push(`/tai-khoan`);
        }
    }
}
</script>